var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#0077FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.62 15.86C8.44 15.86 6.05 12.99 5.95 8.22H8.04C8.11 11.72 9.65 13.2 10.86 13.51V8.22H12.82V11.24C14.02 11.11 15.28 9.74 15.7 8.22H17.66C17.34 10.09 15.98 11.46 15.01 12.02C15.98 12.47 17.52 13.64 18.11 15.86H15.95C15.49 14.41 14.34 13.29 12.82 13.14V15.86H12.62Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.f1537c5a816c50836785f1f022c9e4e2.svg";
export { ForwardRef as ReactComponent };